import { render } from "./aboutUsView.vue?vue&type=template&id=ae78d0cc&scoped=true"
import script from "./aboutUsView.vue?vue&type=script&lang=js"
export * from "./aboutUsView.vue?vue&type=script&lang=js"

import "./aboutUsView.vue?vue&type=style&index=0&id=ae78d0cc&scoped=true&lang=css"

import exportComponent from "/home/beatriz/Documents/GitHub/virtus_consult/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae78d0cc"]])

export default __exports__